import React from "react";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  IconButton,
  IconButtonProps,
  Menu,
  MenuProps,
  SxProps,
} from "@mui/material";

import { UseAnchorElement } from "@app/utils/hooks/useAnchorElement";

export interface OpenMenuButtonProps {
  buttonSx?: SxProps;
  component?: React.ReactElement;
  disabled?: boolean;
  Icon?: typeof MoreHorizIcon;
  id: string;
  menuItems: React.ReactNode[];
  MenuProps?: Partial<MenuProps>;
  ButtonProps?: IconButtonProps;
}

const OpenMenuButton = ({
  anchorElement,
  buttonSx,
  ButtonProps,
  component,
  disabled = false,
  Icon = MoreHorizIcon,
  id,
  menuItems,
  MenuProps,
  open,
  onClose,
  onClick,
}: OpenMenuButtonProps & UseAnchorElement) => {
  return (
    <>
      <IconButton
        aria-controls={open ? id : undefined}
        aria-haspopup
        aria-expanded={open ? "true" : undefined}
        onClick={onClick}
        disabled={disabled}
        sx={{
          ...buttonSx,
          borderRadius: "8px",
          bgcolor: open ? "shades.neutral.ghost.500" : "transparent",
        }}
        {...ButtonProps}
      >
        {component ? (
          component
        ) : (
          <Icon
            sx={{
              width: "20px",
              height: "20px",
              color: disabled
                ? "shades.neutral.200"
                : open
                  ? "shades.primary.500"
                  : "shades.neutral.500",
            }}
          />
        )}
      </IconButton>
      <Menu
        {...MenuProps}
        id={id}
        anchorEl={anchorElement}
        open={open}
        onClose={onClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{
          "& .MuiPaper-root": {
            boxShadow: (theme) => theme.shadows[4],
          },
        }}
      >
        {menuItems}
      </Menu>
    </>
  );
};

export default OpenMenuButton;
